var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("summary-section-layout", {
    attrs: {
      id: "income-history",
      "section-title": _vm.$t(
        "application-standalone.pages.incomeHistory.yourIncomeHistory"
      ),
      "has-missing-information": _vm.hasMissingInformation,
      "section-visibility-values": _vm.sectionVisibilityValues,
    },
    on: {
      edit: function ($event) {
        return _vm.$emit("edit")
      },
    },
    scopedSlots: _vm._u([
      {
        key: "default",
        fn: function (ref) {
          var applicant = ref.applicant
          var applicantIndex = ref.applicantIndex
          return [
            !_vm.applicantHasEmployment(applicant["employment"])
              ? _c("p", { staticClass: "text-light-gray mb-2" }, [
                  _vm._v(
                    "\n      " +
                      _vm._s(
                        _vm.$t(
                          "application-standalone.pages.submit.pleaseAddIncomeDetails"
                        )
                      ) +
                      "\n    "
                  ),
                ])
              : _vm._l(
                  applicant["employment"],
                  function (employment, employmentIndex) {
                    return _c(
                      "p",
                      {
                        key: "employment-" + employmentIndex,
                        staticClass: "mb-2",
                      },
                      [
                        _vm._v(
                          "\n      " +
                            _vm._s(_vm.employmentSummarySubtitle(employment)) +
                            "\n    "
                        ),
                      ]
                    )
                  }
                ),
            _vm._v(" "),
            _vm.additionalIncomeVisibleByApplicant(applicantIndex)
              ? [
                  _c("p", { staticClass: "mt-4 mb-2 bold" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.$t("application-form.additional-income")) +
                        "\n      "
                    ),
                  ]),
                  _vm._v(" "),
                  !_vm.applicantHasAdditionalIncome(applicant["other-income"])
                    ? _c("p", { staticClass: "text-light-gray mb-2" }, [
                        _vm._v(
                          "\n        " +
                            _vm._s(
                              _vm.$t(
                                "application-standalone.pages.submit.pleaseAddIncomeDetails"
                              )
                            ) +
                            "\n      "
                        ),
                      ])
                    : _vm._l(
                        applicant["other-income"],
                        function (otherIncome, otherIncomeIndex) {
                          return _c(
                            "p",
                            {
                              key: "other-income-" + otherIncomeIndex,
                              staticClass: "mb-2",
                            },
                            [
                              _vm._v(
                                "\n        " +
                                  _vm._s(
                                    _vm.additionalIncomeSummarySubtitle(
                                      otherIncome
                                    )
                                  ) +
                                  "\n      "
                              ),
                            ]
                          )
                        }
                      ),
                ]
              : _vm._e(),
          ]
        },
      },
    ]),
  })
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }